'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _license = require('../../utils/normalizers/license');
var _underscoreNotationToCamelCase = require('../../utils/underscoreNotationToCamelCase');var _underscoreNotationToCamelCase2 = _interopRequireDefault(_underscoreNotationToCamelCase);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var fields = ['license_number', 'company_name'];var requiredFields = ['agent_data.license_number', 'agent_data.company_name'];var

RealEstateDetails = function (_Component) {_inherits(RealEstateDetails, _Component);function RealEstateDetails() {var _temp, _this, _ret;_classCallCheck(this, RealEstateDetails);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    renderFormGroup = function (_ref) {var input = _ref.input,meta = _ref.meta;
      var name = (0, _underscoreNotationToCamelCase2.default)(input.name).split('.').pop();
      var tooltipMessagePostfix = 'TooltipMessage';
      var tooltipMessage = void 0;
      var validate = null;

      if (input.name === 'agent_data.license_number') {
        tooltipMessage = '' + _this.props.translate('realEstateDetails', name + tooltipMessagePostfix);
        validate = function validate(val) {return val.length >= 4;};
      }

      return _react2.default.createElement(_components.OMFormGroup, _extends({},
      input,
      meta, {
        validate: validate,
        label: '' + _this.props.translate('realEstateDetails', name),
        tooltipMessage: tooltipMessage,
        title: '' + _this.props.translate('realEstateDetails', name),
        isMobile: _this.props.isMobile,
        isRequired: requiredFields.indexOf(input.name) !== -1,
        isRtl: _this.props.isRtl }));

    }, _temp), _possibleConstructorReturn(_this, _ret);}RealEstateDetails.prototype.componentDidMount = function componentDidMount() {var _this2 = this;fields.forEach(function (item) {return _this2.props.registerNewField('agent_data.' + item);});};RealEstateDetails.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: this.props.className },
        _react2.default.createElement(_reactScroll.Element, { name: 'license_number' },
          _react2.default.createElement(_reduxForm.Field, {
            props: { locale: this.props.locale },
            name: 'agent_data.license_number',
            normalize: _license.license,
            component: this.renderFormGroup })),


        _react2.default.createElement(_reduxForm.Field, {
          props: { locale: this.props.locale },
          name: 'agent_data.company_name',
          component: this.renderFormGroup })));



  };return RealEstateDetails;}(_react.Component);


RealEstateDetails.propTypes = {
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  className: _propTypes2.default.string,
  registerNewField: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool };exports.default =


RealEstateDetails;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealEstateDetails/RealEstateDetails.js
// module id = 2866
// module chunks = 0